// extracted by mini-css-extract-plugin
export default {"no-target-icon":"zoomList_no-target-icon__2EoUt","add-icon":"zoomList_add-icon__lJ1sv"};